// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-6e34e028].require> .el-input{\r\n    border: red 1px solid;\n}\n.item[data-v-6e34e028]{width:calc(100% - 30px)}\r\n", ""]);
// Exports
module.exports = exports;
